// extracted by mini-css-extract-plugin
export default {"wrapper":"xG-z","response":"yG-z","error":"zG-z","disabled":"AG-z","buttons":"BG-z","feedbackQuestionSection":"CG-z","yesNoWrapper":"DG-z"};